export default "__VITE_ASSET__CI$JSS3Q__";